/* tslint:disable */

import { ReaderFragment } from "relay-runtime";
type ShippingDetailsAddress_item$ref = any;
type ShippingDetailsQuotesTable_relevantShippingInfo$ref = any;
type ShippingDetailsQuotesTable_shipmentQuotes$ref = any;
export type ShippingDetailsContainer_viewer$ref = any;
export type ShippingDetailsContainer_viewer = {
    readonly item?: {
        readonly " $fragmentRefs": ShippingDetailsAddress_item$ref;
    } | null;
    readonly relevantShippingInfo?: {
        readonly " $fragmentRefs": ShippingDetailsQuotesTable_relevantShippingInfo$ref;
    } | null;
    readonly shipmentQuotes?: {
        readonly " $fragmentRefs": ShippingDetailsQuotesTable_shipmentQuotes$ref;
    } | null;
    readonly " $refType": ShippingDetailsContainer_viewer$ref;
};



const node: ReaderFragment = (function () {
    var v0 = ({
        "kind": "Variable",
        "name": "itemId",
        "variableName": "itemId"
    } as any);
    return {
        "kind": "Fragment",
        "name": "ShippingDetailsContainer_viewer",
        "type": "Viewer",
        "metadata": null,
        "argumentDefinitions": [
            {
                "kind": "RootArgument",
                "name": "itemId",
                "type": "String!"
            },
            {
                "kind": "RootArgument",
                "name": "shouldFetchItem",
                "type": "Boolean"
            },
            {
                "kind": "RootArgument",
                "name": "userId",
                "type": "String"
            }
        ],
        "selections": [
            {
                "kind": "Condition",
                "passingValue": true,
                "condition": "shouldFetchItem",
                "selections": [
                    {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "item",
                        "storageKey": null,
                        "args": [
                            (v0 /*: any*/),
                            {
                                "kind": "Literal",
                                "name": "pageType",
                                "value": "SHIPPING_MODAL"
                            }
                        ],
                        "concreteType": "Item",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "FragmentSpread",
                                "name": "ShippingDetailsAddress_item",
                                "args": null
                            }
                        ]
                    },
                    {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "relevantShippingInfo",
                        "storageKey": null,
                        "args": [
                            {
                                "kind": "Variable",
                                "name": "buyerId",
                                "variableName": "userId"
                            },
                            (v0 /*: any*/)
                        ],
                        "concreteType": "QueryRelevantShippingInfo",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "FragmentSpread",
                                "name": "ShippingDetailsQuotesTable_relevantShippingInfo",
                                "args": null
                            }
                        ]
                    },
                    {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "shipmentQuotes",
                        "storageKey": null,
                        "args": [
                            {
                                "kind": "Literal",
                                "name": "first",
                                "value": 10
                            },
                            (v0 /*: any*/),
                            {
                                "kind": "Literal",
                                "name": "searchView",
                                "value": "IGNORE_LOCAL_PICKUP"
                            }
                        ],
                        "concreteType": "ShipmentQuotesConnection",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "FragmentSpread",
                                "name": "ShippingDetailsQuotesTable_shipmentQuotes",
                                "args": null
                            }
                        ]
                    }
                ]
            }
        ]
    } as any;
})();
(node as any).hash = '3116d7d257c6354afb4cb1feb0b63a39';
export default node;
